module.exports = __webpack_public_path__ + "static/media/location-maps-letter-d-arrow.6500edc3.png";